import axios from "axios";
import { serverApi } from "../../lib/config";
import { Review, ReviewPage } from "../../lib/types/review";

class ReviewService {
  private readonly path = serverApi;

  public async getCommunity(page = 1, limit = 12, productId?: string): Promise<ReviewPage> {
    let url = `${this.path}/review/all?page=${page}&limit=${limit}`;
    if (productId) url += `&productId=${productId}`;
    const result = await axios.get(url);
    return result.data;
  }

  public async createReview(input: {
    productId: string;
    reviewText: string;
    reviewRating: number;
  }): Promise<Review> {
    const result = await axios.post(`${this.path}/review/create`, input, {
      withCredentials: true,
    });
    return result.data;
  }

  public async likeReview(reviewId: string) {
    const result = await axios.post(
      `${this.path}/review/${reviewId}/like`,
      {},
      { withCredentials: true }
    );
    return result.data;
  }

  public async replyReview(reviewId: string, replyText: string) {
    const result = await axios.post(
      `${this.path}/review/${reviewId}/reply`,
      { replyText },
      { withCredentials: true }
    );
    return result.data;
  }
}

export default ReviewService;
